import React from "react" ;
import "../../styles/UI/postCard.scss";
import { Globals } from "root/DataFunctions/BaseDataFns";
import {getDocumentUrl} from "root/DataFunctions/CommonDataFns";

const PostCard = ({ lifeStory, setIndexFromPost, postIndex }) => {
    const {title, text, event_date, post_doc_id} = lifeStory;
    const document_id = lifeStory.image_array[0];
    const url = getDocumentUrl(document_id, 200, true, lifeStory.document_array[0]) ;
    const externalLinkUrl = Globals.BaseURL + "/images/icons/child/external-link.png";
    const videoUrl = Globals.BaseURL + "/images/icons/child/youtube.png";
    const docUrl = Globals.BaseURL + "/images/icons/child/document.png";

    const Attachment = ({post}) => {

        const documentUrl = '/getFile.php?enc_docid=' + post.document_array[0];

        if (post.link) {
            return (
                <a href={post.link} target="_blank" rel="noreferrer noopener">
                    <div className="article-external">
                        <img className="article-external-video" src={videoUrl} alt="video" />
                    </div>
                </a>
            )
        }else if (post.post_doc_id) {
            return (
                <a href={documentUrl} target="_blank" rel="noreferrer noopener">
                    <div className="article-external">
                        <img className="article-external-doc" src={docUrl} alt="document" />
                    </div>
                </a>
            )
        } else {
            return "";
        }
    }
    
    return (
        // <article className="article-card">
        <article 
            className={(lifeStory.post_doc_id || lifeStory.link) ?
                "article-card article-card_link"
                :
                "article-card"
                }
        >
            <figure onClick={() => setIndexFromPost(postIndex)} className="article-image">
                { lifeStory.link &&
                    <div>
                        <iframe
                            src={lifeStory.link}
                            frameBorder="0"
                            allowFullScreen
                        >
                        </iframe>
                    </div>
                }
                {!lifeStory.link &&
                    <img src={url} alt={title}/>
                }
            </figure>

            <Attachment post={lifeStory} />

            <div className="article-content">
                <div>
                    <span className="card-category">
                        {event_date}
                    </span>
                    <h3 className="card-title">{title}</h3>
                    <p className="card-excert">{text}</p>
                </div>

                {/* {post_doc_id !== null && <div>
                    <a href={getDocUrl()} target="_blank">
                        <img alt="document" width="70" src={getDocumentIcon()} ></img>
                    </a>
                </div>} */}
            </div>

        </article>
    );
}

export default PostCard;
